import React, { useState, useEffect } from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  useTranslate,
  BooleanInput,
  useNotify,
  useRedirect,
  required,
} from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { applicationServices } from 'src/services/auth/application/application.service'
import { moduleServices } from 'src/services/auth/module/module.service'
import { clientServices } from 'src/services/auth/client/client.service'
import { isJsonValidate } from 'src/helper/validatorJson'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'

export const ProcessCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [clients, setClients] = useState([])
  const [loadingClients, setLoadingClients] = useState(true)
  const [applications, setApplications] = useState([])
  const [loadingApplications, setLoadingApplications] = useState(false)
  const [modules, setModules] = useState([])
  const [loadingModules, setLoadingModules] = useState(false)

  useEffect(() => {
    ;(async () => {
      setLoadingClients(true)
      try {
        const allClients = await clientServices.getByAll()
        if (allClients) {
          setClients(allClients)
          setLoadingClients(false)
          return
        }
        notify(`applications not found`, { type: 'error' })
        setLoadingClients(false)
      } catch (error) {
        notify(`please, refresh page`, { type: 'error' })
        setLoadingClients(false)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getApplicationsByClient = async (idClient) => {
    setModules([])
    setLoadingApplications(true)
    if (idClient) {
      try {
        let allApplications = await applicationServices.getApplicationByClient(idClient)
        setApplications(allApplications.map((item) => item.application))
        setLoadingApplications(false)
      } catch (error) {
        notify(`applications not found`, { type: 'error' })
        setLoadingApplications(false)
        return
      }
    }
  }

  const getModulesByApplication = async (idApplication) => {
    setLoadingModules(true)
    if (idApplication) {
      try {
        let allModules = await moduleServices.getModulesByApplications(idApplication)
        setModules(allModules)
        setLoadingModules(false)
      } catch (error) {
        notify(`please, refresh page`, { type: 'error' })
        setModules([])
        setLoadingModules(false)
      }
    }
  }

  const onSuccess = () => {
    notify('ra.notification.created_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.process') }
    })
    redirect('/process')
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.process') }
    })
  }

  const transform = (data) => ({
    short_name: data.short_name,
    long_name: data.long_name,
    text: data.text,
    module_id: data.module_id,
    client_id: data.client_id,
    state: data.state,
    config: data.config,
  })

  return (
    <Create {...props} transform={transform} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_process')}>
        <SimpleForm>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.short_name')} required>
              <TextInput source='short_name' label='' fullWidth validate={required()} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.long_name')}>
              <TextInput source='long_name' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.text')}>
              <TextInput source='text' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.client')} required>
              {loadingClients ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='client_id'
                  optionsText={['long_name']}
                  label=''
                  fullWidth
                  options={clients}
                  onChange={(e) => getApplicationsByClient(e.target.value)}
                  validate={required()}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.application')} required>
              {loadingApplications ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='application_id'
                  optionsText={['long_name']}
                  label=''
                  fullWidth
                  options={applications}
                  onChange={(e) => getModulesByApplication(e.target.value)}
                  validate={required()}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.module')} required>
              {loadingModules ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='module_id'
                  optionsText={['long_name']}
                  options={modules}
                  label=''
                  fullWidth
                  validate={required()}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.config')}>
              <TextInput
                source='config'
                label={false}
                multiline
                rows={5}
                fullWidth
                validate={isJsonValidate}
                format={(v) => {
                  return typeof v === 'object' ? JSON.stringify(v) : v
                }}
                parse={(v) => {
                  try {
                    return (v && v.length >= 2) ? JSON.parse(v) : v
                  } catch (e) {
                    return v || undefined
                  }
                }}
              />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.state')}>
              <BooleanInput source='state' fullWidth label={translate('ra.field.is_active')} />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
